(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bsklri-btt"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    var doc = document;
    if (doc.documentElement.hasAttribute('data-btt-ready')) return;   /* 双保险：防重复初始化 */
    var btn = doc.querySelector('[data-bsklri-btt]');
    if (!btn) return;
    doc.documentElement.setAttribute('data-btt-ready', '1');

    /* ★★ 2026-10-22 升级保险：旧版 syncChat() 会把 inline `left / right:auto / bottom` 写到按钮上，
       inline 永远压过样式表 ⇒ 新 CSS 的 right / bottom 全部失效，两个按钮各按各的基准摆
       （就是「上下分离 / PC 重叠」的成因）。这里一次性清掉，之后定位纯 CSS，不再有 inline。 */
    btn.style.removeProperty('left');
    btn.style.removeProperty('right');
    btn.style.removeProperty('bottom');

    var SHOW_AT = 500;    /* 显示阈值：scrollTop > 500 */
    var HIDE_AT = 480;    /* 隐藏阈值：留 20px 缓冲，防临界抖动 */
    var DURATION = 500;   /* 回顶动画时长 ms（与 Vitals 原按钮实测一致） */

    /* ★★ 2026-10-24：显示前再加一道「气泡已就位」的门（她拍板）。
       原因：气泡尺寸由 chat-drawer 探测后写进 --inbox-h，探测未完成时本按钮用 50px 兜底，
       位置就会差几像素 —— 看起来就贴在气泡上。所以气泡没探到之前先不显示。
       保底：从脚本执行算起 CHAT_WAIT 毫秒还没探到（Inbox 没装 / 被拦截 / 探到 20s 上限），
       照常显示并走 50px 兜底 —— 那种情况气泡根本不存在，也就谈不上对齐。 */
    var CHAT_WAIT = 5000;
    var bootAt = Date.now();
    function canShow() {
      /* ★ 2026-10-28：本文件自测到气泡尺寸（data-btt-chat，见上方内联脚本）也算就位 ——
         不再依赖 chat-drawer 的 data-chat-ready（它要等 20s 才写，气泡却可能更晚才出现）。 */
      return btn.hasAttribute('data-btt-chat') ||
             doc.documentElement.hasAttribute('data-chat-ready') ||
             (Date.now() - bootAt) >= CHAT_WAIT;
    }

    var fillEl = btn.querySelector('[data-btt-fill]');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var rafId = 0, lastRoot = null, lastDist = 0, barEl = null, lastLift = -1;

    function isDocTarget(t) {
      return t === doc || t === window || t === doc.documentElement || t === doc.body;
    }
    function metrics(root) {
      var isDocEl = isDocTarget(root) || root === doc.scrollingElement || root === doc.documentElement;
      var st  = isDocEl ? (window.pageYOffset || root.scrollTop) : root.scrollTop;
      var max = isDocEl ? (root.scrollHeight - window.innerHeight) : (root.scrollHeight - root.clientHeight);
      return { st: st, max: max };
    }

    function sync(root) {
      var m = metrics(root);
      var pct = m.max > 0 ? Math.max(0, Math.min(1, m.st / m.max)) : 0;
      fillEl.style.height = (pct * 100).toFixed(2) + '%';
      var vis = btn.classList.contains('is-visible');
      if (!vis && m.st > SHOW_AT && canShow()) { btn.classList.add('is-visible'); }
      else if (vis && m.st < HIDE_AT) { btn.classList.remove('is-visible'); }
    }

    /* 吸底加购条避让（兜底路径）：实测「条高 + 条自身的 bottom 偏移」写进 --btt-bar，
       与 sections/bsklri-pdp2-sticky-atc.liquid 的 syncLift() 同一口径（height + bottom）。
       主路径是 CSS 里的 --shopify-chat-activator-offset（与气泡共用），--btt-bar 只在
       没有 Inbox / chat-drawer 未 render 时才被 max() 取到，所以这里查不到条也完全无害。 */
    function syncBar() {
      if (barEl && !barEl.isConnected) { barEl = null; lastLift = -1; }
      if (!barEl) barEl = doc.querySelector('.Vtl-StickyAddToCart, bsklri-pdp2-sa');
      var lift = 0;
      if (barEl && (barEl.classList.contains('Vtl-StickyAddToCart--isVisible') ||
                    barEl.classList.contains('is-visible'))) {
        var r = barEl.getBoundingClientRect();
        if (r.height > 0) {                                 /* display:none 时 height=0，别把 bottom 偏移算进去 */
          var gap = parseFloat(getComputedStyle(barEl).bottom) || 0;
          lift = Math.round(r.height + gap);
        }
      }
      if (lift !== lastLift) { lastLift = lift; btn.style.setProperty('--btt-bar', lift + 'px'); }
    }

    /* ★★ 2026-10-22 删除 syncChat() / findChatBtn() / digActivator()：
       本按钮位置改由 CSS 与 Inbox 气泡共用 --shopify-chat-activator-offset 决定，不再读别人的矩形。
       旧实现线上实测到的三个病（改回来就会复发）：
         · 气泡用 220ms CSS 过渡上浮，这里只在「滚动那一帧」采到起点 → 滚动一停两者分离，
           最多要等 1s 轮询才归位（实测气泡走了 123px，本按钮只挪 8px）；
         · 每帧重设 bottom，而本按钮自己也有 transition → 过渡被反复重启，
           571ms 才走完本该 200ms 的位移（视觉「蠕行」）；
         · 找不到气泡时清空内联 left/right/bottom，落回右锚 → 水平横跳 24px。 */

    /* 滚动监听：document 捕获相 —— 元素内滚动与整页滚动都能收到。
       ★ 只认「可滚量够大」的垂直滚动源：横向轮播 / 小组件内滚 / 被聚焦弹层
       顶出来的 document 假滚动一律忽略，否则按钮会被劫持（进度清零、按钮
       消失、点击不滚）。新源必须比当前源更大才准顶替。 */
    function onScroll(e) {
      var isDoc = isDocTarget(e.target);
      var el = isDoc ? (doc.scrollingElement || doc.documentElement) : e.target;
      var d = el.scrollHeight - el.clientHeight;
      if (d <= 60) return;                                             /* 横向轮播 / 小内滚：忽略 */
      if (!isDoc && !/(auto|scroll|overlay)/.test(getComputedStyle(el).overflowY)) return;
      if (lastRoot && lastRoot !== el && d < lastDist) return;         /* 比当前滚动源小：不抢 */
      lastRoot = el; lastDist = d;
      if (rafId) return;
      rafId = requestAnimationFrame(function () { rafId = 0; syncBar(); sync(lastRoot); });
    }
    doc.addEventListener('scroll', onScroll, { capture: true, passive: true });
    window.addEventListener('resize', function () {
      syncBar();
      if (!lastRoot) return;
      lastDist = lastRoot.scrollHeight - lastRoot.clientHeight;
      if (lastDist <= 60) { lastRoot = null; lastDist = 0; return; }   /* 布局变化后旧滚动源失效 → 下次滚动重新认领 */
      sync(lastRoot);
    }, { passive: true });
    /* 气泡探到的那一刻补算一次：用户可能早就滚过 500 了（此前一直被上面那道门挡着，没有 scroll 事件可等） */
    doc.addEventListener('bsklri:chat-ready', function () { if (lastRoot) sync(lastRoot); });
    /* 保底门开的那一刻也补算一次（不滚动就不会有 scroll 事件） */
    setTimeout(function () { if (lastRoot) sync(lastRoot); }, CHAT_WAIT + 120);
    /* 吸底条出现/消失可能不触发滚动（如加购条由 IO 驱动）：1s 低频兜底（无变化则零副作用）。
       ★ 定位本身是纯 CSS，不依赖这个轮询；它只服务 --btt-bar 的兜底值。 */
    setInterval(syncBar, 1000);

    /* ---- 回顶动画：rAF 逐帧、easeInOutCubic、500ms、可被用户输入打断 ---- */
    var anim = null;   /* { root, raf, prevSB } */
    function cancelAnim() {
      if (!anim) return;
      cancelAnimationFrame(anim.raf);
      anim.root.style.scrollBehavior = anim.prevSB;
      anim = null;
    }
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, cancelAnim, { passive: true, capture: true });
    });
    function ease(k) {
      return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
    }

    /* 减弱动效路径专用：瞬时跳顶（同样要压平 CSS 平滑，否则浏览器会自作主张滚 ~550ms 动画） */
    function jumpTop(root) {
      var p = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      root.scrollTop = 0;
      root.style.scrollBehavior = p;
      sync(root);
    }

    btn.addEventListener('click', function () {
      var root = lastRoot || doc.scrollingElement || doc.documentElement;
      if (reduced.matches) { jumpTop(root); return; }   /* 减弱动效：直接跳顶 */
      cancelAnim();
      var from = root.scrollTop;
      var t0 = performance.now();
      var prevSB = root.style.scrollBehavior;      /* ★ 主题的 scroll-behavior:smooth 先压平 */
      root.style.scrollBehavior = 'auto';
      var a = { root: root, prevSB: prevSB, raf: 0 };
      a.raf = requestAnimationFrame(function step(now) {
        var k = Math.min(1, (now - t0) / DURATION);
        root.scrollTop = from * (1 - ease(k));
        if (k < 1) { a.raf = requestAnimationFrame(step); }
        else { root.style.scrollBehavior = prevSB; anim = null; }
      });
      anim = a;
    });

    /* ---- 初始状态（带滚动位置载入时）：一次性探测可滚量最大的容器 ---- */
    requestAnimationFrame(function () {
      syncBar();
      var best = null, bestD = 60;
      var all = doc.querySelectorAll('div,main,section,aside');
      for (var i = 0; i < all.length; i++) {
        var d = all[i].scrollHeight - all[i].clientHeight;
        if (d > bestD && /(auto|scroll|overlay)/.test(getComputedStyle(all[i]).overflowY)) {
          best = all[i]; bestD = d;
        }
      }
      if (best) { lastRoot = best; lastDist = bestD; sync(best); }
      else {
        var se = doc.scrollingElement || doc.documentElement;
        if (se.scrollTop > 0) { lastRoot = se; sync(se); }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bsklri-reveal"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    window.__bsklriRvReady = true;

    var showAll = function (scope) {
      var els = (scope || document).querySelectorAll('[data-reveal]:not(.rv-in)');
      for (var i = 0; i < els.length; i++) els[i].classList.add('rv-in');
    };

    /* 主题编辑器里改版块会动态重渲染：直接显形 + 不播动画（挂 rv-off） */
    if (window.Shopify && window.Shopify.designMode) {
      document.documentElement.classList.add('bsklri-rv-off');
      showAll();
      document.addEventListener('shopify:section:load', function () {
        showAll();
      });
      return;
    }

    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('rv-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05 }
    );
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chat-drawer"] && !Shopify.designMode) return;
  try {
    /* 聊天按钮高度避让（2026-10-21）
     目的：底部吸底栏（PDP 吸底加购条，Vitals 或主题自带、以后换插件都算）一出现，
           按钮自动抬到条顶上方，不再被压在条里。
     做法：运行时实测「贴底 fixed 容器」的高度写进 --chat-bar-h（CSS 再用 max() 算最终离底）。
     实测路径两条：
       A. 已知类名（自建 `bsklri-pdp2sa` / Vitals `.Vtl-StickyAddToCart` / `*StickyAddToCart*` / `*sticky-add-to-cart*`）
       B. 通用：视口底部左中右 × 5 档高度采点 → 沿祖先链（可跨 shadow）找贴底 fixed 且宽度 ≥34% 视口的容器
     ★ 2026-10-21 二改：采点从「单点 vh-4」改成 5 档（离底 3/14/30/52/84）——
       因为加购条改成「悬浮卡片」后底部有 10px 边距、iPhone 还有 34px 安全区，
       原来那一点会落在条下方的空隙里 → 采不到条 → 按钮不抬（线上被压的根因）。
     ★★ 2026-10-22 三改：**自建吸底条在场的页面，本脚本直接让位**（见下方第一行判断）。
       原因：这里和 sections/bsklri-pdp2-sticky-atc.liquid 的 syncLift() 是**两个写入者**，
       口径还不一样——自建条上报 `height + bottom偏移` = 184px（准确），
       本脚本按几何采点算 `vh - r.top`，在条 0.3s 入场动画期间会读到 178px。
       两个值互相覆盖 ⇒ 气泡离底高度在 184↔178 之间来回变，每变一次就走 220ms 过渡，
       线上肉眼看到的就是「气泡莫名上下抽 6px」。自建条的值更准，所以让它独占。
       ★ 另记一条 CSSOM 坑：`setProperty(name, value)` 不带第三参时 priority 为空，
       **会清掉同名声明已有的 !important** —— 别指望 important 能挡住别的行内写入。
     触发：滚动（捕获相，覆盖整页与内滚）/ 缩放 / 转屏 / DOM 增删（第三方 App 后注入）/ 1.5s 兜底。 */
  (function () {
    'use strict';
    var doc = document;
    var root = doc.documentElement;
    if (!doc.body || root.hasAttribute('data-chat-lift-ready')) return;
    root.setAttribute('data-chat-lift-ready', '1');

    /* ★★ 2026-10-24：气泡尺寸改成「盯到它出现为止」再测（原来只测 加载时 + 1.2s 两次）。
       为什么必须改：Inbox 是第三方异步注入 —— 实测桌面 2.5s 时 <shopify-chat> 宿主已经在 DOM 里，
       直到 14.8s 才长出有尺寸的 activator。而变化发生在它的 shadow DOM 内部，
       document 上的 MutationObserver 收不到 ⇒ 固定 1.2s 那次必然错过，
       --inbox-h 一直是空，返回顶部按钮只能按 50px 兜底（间距从 12 变 4~9px，看起来「堆在一起」）。
       现在：300ms 探一次、最多 20s，探到即写值 + 给 html 打 data-chat-ready + 抛 bsklri:chat-ready，
       然后彻底停（不空转）；resize / 转屏的重测永久保留。 */
    (function syncChatSize() {
      var last = '', tries = 0, timer = 0, found = false;
      var MAX_TRIES = 66;            /* 66 × 300ms ≈ 20s 上限，之后不再探（Inbox 真没装/被拦） */
      var TICK = 300;

      function dig(r) {
        if (!r) return null;
        var all = r.querySelectorAll('*');
        for (var i = 0; i < all.length; i++) {
          var p = (all[i].getAttribute && all[i].getAttribute('part')) || '';
          if ((' ' + p + ' ').indexOf(' activator ') >= 0) {
            var b = all[i].getBoundingClientRect();
            if (b.width >= 8 && b.height >= 8) return b;
          }
          if (all[i].shadowRoot) { var s = dig(all[i].shadowRoot); if (s) return s; }
        }
        return null;
      }

      function stop() { if (timer) { clearInterval(timer); timer = 0; } }

      function apply(rect) {
        var w = Math.round(rect.width), h = Math.round(rect.height);
        var k = w + 'x' + h;
        if (k !== last) {
          last = k;
          root.style.setProperty('--inbox-w', w + 'px');
          root.style.setProperty('--inbox-h', h + 'px');
        }
        if (!found) {
          found = true;
          stop();
          root.setAttribute('data-chat-ready', k);
          try {
            doc.dispatchEvent(new CustomEvent('bsklri:chat-ready', { detail: { w: w, h: h } }));
          } catch (e) {}
        }
      }

      function run() {
        var hosts = doc.querySelectorAll('shopify-chat'), rect = null;
        for (var i = 0; i < hosts.length && !rect; i++) rect = dig(hosts[i].shadowRoot);
        if (!rect) return false;
        apply(rect);
        return true;
      }

      if (!run()) {
        timer = setInterval(function () {
          if (run()) return;                 /* apply() 里已经 stop() */
          if (++tries >= MAX_TRIES) stop();
        }, TICK);
      }
      window.addEventListener('resize', run, { passive: true });
      window.addEventListener('orientationchange', run, { passive: true });
    })();

    /* ★★ 单一写者：自建吸底条在 → 用它 syncLift() 上报的精确值（height + bottom 偏移），
       本脚本不再参与，否则两种口径互相顶掉（184 / 178）导致气泡上下抽。
       其它页面（没有自建条）继续走下面的通用探测，不影响。 */
    if (doc.querySelector('bsklri-pdp2-sa')) return;

    var vh = 0, vw = 0, lastH = -1, rafId = 0, moTimer = 0;

    /* 这些节点不能被当成「吸底栏」：聊天宿主自己 / 返回顶部按钮 / 主题抽屉 */
    function isNoise(el) {
      if (!el || el.nodeType !== 1) return true;
      if (el.tagName === 'SHOPIFY-CHAT' || el.id === 'chat-drawer') return true;
      if (el.hasAttribute && el.hasAttribute('data-bsklri-btt')) return true;
      if (el.closest && el.closest('[data-bsklri-btt], #chat-drawer, shopify-chat')) return true;
      return false;
    }

    /* 沿祖先链（可跨 shadow 边界）找最近的贴底 fixed 容器，返回「顶边到视口底」的距离 ≈ 条高 */
    function barFromNode(node) {
      for (var i = 0; node && node.nodeType === 1 && i < 16; i++) {
        if (isNoise(node)) return 0;
        var cs = getComputedStyle(node);
        if (cs.position === 'fixed') {
          if (cs.display === 'none' || cs.visibility === 'hidden') return 0;
          if (parseFloat(cs.opacity) < 0.15) return 0;          /* 淡出/隐藏态不算（条收起时只是滑下去，还露一条边） */
          var r = node.getBoundingClientRect();
          var tall = r.height >= 24 && r.height <= vh * 0.62;   /* 太高 = 全屏层，不是条 */
          var wide = r.width >= vw * 0.34;
          var glued = r.bottom >= vh - 64;                      /* 底边在视口底部 64px 内（含悬浮卡片边距 / iOS 安全区） */
          var low = r.top >= vh * 0.3 && r.top <= vh - 32;      /* 顶边在视口下半部，且真的露出来（不是滑到屏下的隐藏态） */
          return (tall && wide && glued && low) ? Math.round(vh - r.top) : 0;
        }
        node = node.parentElement || (node.getRootNode && node.getRootNode().host);
      }
      return 0;
    }

    function measure() {
      vh = window.innerHeight;
      vw = window.innerWidth;
      var best = 0, i, r, cs;

      /* A. 已知类名（自建的条排第一：类名最确定，不依赖几何猜测） */
      var known = null;
      try {
        known = doc.querySelectorAll('bsklri-pdp2-sa, [class*="bsklri-pdp2sa"], .Vtl-StickyAddToCart, [class*="StickyAddToCart"], [class*="sticky-add-to-cart"]');
      } catch (e) { known = null; }
      if (known) {
        for (i = 0; i < known.length; i++) {
          cs = getComputedStyle(known[i]);
          if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') continue;
          if (parseFloat(cs.opacity) < 0.15) continue;
          r = known[i].getBoundingClientRect();
          if (r.height < 24 || r.height > vh * 0.62 || r.width < vw * 0.34) continue;
          if (r.bottom < vh - 64 || r.top < vh * 0.3 || r.top > vh - 32) continue;
          if (Math.round(vh - r.top) > best) best = Math.round(vh - r.top);
        }
      }

      /* B. 通用采点（换插件 / 新增贴底条也能认出来）
         纵向 5 档：贴底条（3）/ 悬浮卡片留 10px（14）/ 安全区+Dock（30）/ iOS 安全区 34（52）/ 更厚的条（84） */
      if (vw > 0 && doc.elementsFromPoint) {
        var xs = [0.5, 0.28, 0.72];
        var ys = [3, 14, 30, 52, 84];
        for (var q = 0; q < ys.length; q++) {
          var py = Math.max(1, vh - ys[q]);
          for (var p = 0; p < xs.length; p++) {
            var stack = doc.elementsFromPoint(Math.round(vw * xs[p]), py) || [];
            for (var s = 0; s < stack.length; s++) {
              var h = barFromNode(stack[s]);
              if (h > best) best = h;
            }
          }
        }
      }
      return best;
    }

    function apply() {
      rafId = 0;
      var h = measure();
      if (h === lastH) return;
      lastH = h;
      doc.body.style.setProperty('--chat-bar-h', h + 'px');
    }
    function schedule() { if (!rafId) rafId = requestAnimationFrame(apply); }

    doc.addEventListener('scroll', schedule, { capture: true, passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    if (window.MutationObserver && doc.body) {
      try {
        new MutationObserver(function () {
          clearTimeout(moTimer);
          moTimer = setTimeout(schedule, 180);
        }).observe(doc.body, { childList: true, subtree: true });
      } catch (e) {}
    }
    schedule();
    setInterval(schedule, 1500);   /* 兜底：条出现/消失没触发上面任何事件时 */
  })();
  } catch(e) { console.error(e); }
})();

})();
